interface TemplateReplacements {
  product_name?: string;
  quantity?: number | string;
  [key: string]: string | number | undefined;
}

export function replaceTemplateVariables(
  template: string | undefined,
  replacements: TemplateReplacements
): string {
  if (!template) {
    return '';
  }

  return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const value = replacements[key];

    if (value !== undefined && value !== null) {
      return String(value);
    }

    return match;
  });
}
